var calendar = [];
var end;

function findOrCreateYear(date) {
  if (
    !_.some(calendar, {
      name: date.year(),
    })
  ) {
    calendar.push({
      name: date.year(),
      months: [],
    });
  }
  return _.find(calendar, {
    name: date.year(),
  });
}

function findOrCreateMonth(date, year) {
  if (
    !_.some(year.months, {
      year: date.year(),
      name: date.format('MMMM'),
      index: date.month(),
    })
  ) {
    year.months.push({
      year: date.year(),
      name: date.format('MMMM'),
      index: date.month(),
      weeks: [],
    });
  }
  return _.find(year.months, {
    index: date.month(),
  });
}

function findOrCreateWeek(date, month) {
  if (
    !_.some(month.weeks, {
      number: date.week(),
    })
  ) {
    month.weeks.push({
      number: date.week(),
      days: [
        {
          valid: false,
          selected: false,
          focused: false,
          index: 1,
          sort: 0,
        },
        {
          valid: false,
          selected: false,
          focused: false,
          index: 2,
          sort: 1,
        },
        {
          valid: false,
          selected: false,
          focused: false,
          index: 3,
          sort: 2,
        },
        {
          valid: false,
          selected: false,
          focused: false,
          index: 4,
          sort: 3,
        },
        {
          valid: false,
          selected: false,
          focused: false,
          index: 5,
          sort: 4,
        },
        {
          valid: false,
          selected: false,
          focused: false,
          index: 6,
          sort: 5,
        },
        {
          valid: false,
          selected: false,
          focused: false,
          index: 0,
          sort: 6,
        },
      ],
    });
  }
  return _.find(month.weeks, {
    number: date.week(),
  });
}

function findDay(calendar, date) {
  var year = _.find(calendar, {
    name: date.year(),
  });
  var month = _.find(year.months, {
    index: date.month(),
  });
  var week = _.find(month.weeks, {
    number: date.week(),
  });
  return _.find(week.days, {
    index: date.day(),
  });
}

function createDay(date, week) {
  day = _.find(week.days, {
    index: date.day(),
  });
  day.number = date.format('DD');
  day.name = date.format('dddd');
  day.year = date.format('YYYY');
  day.valid = true;
  day.short = date.format('ll');
  day.full = date.format('DD.MM.YYYY');
  day.date_format = date.format('YYYY-MM-DD');
  day.times = [];
  day.month = date.format('MMMM');
  day.week_number = date.week();
}

var get = function (years) {
  if (_.isUndefined(years)) {
    years = 1;
  }
  end = moment().add(years, 'year');
  for (var current = moment(); current.isBefore(end); current.add(1, 'days')) {
    year = findOrCreateYear(current);
    month = findOrCreateMonth(current, year);
    week = findOrCreateWeek(current, month);
    createDay(current, week);
  }
  return _.cloneDeep(calendar);
};

var eachDay = function (calendar, callback) {
  _.forEach(calendar, function (year) {
    _.forEach(year.months, function (month) {
      _.forEach(month.weeks, function (week) {
        _.forEach(week.days, callback);
      });
    });
  });
};

var getTimeOptions = function (step) {
  var options = [];
  var end = moment('1970-01-02 00:00:01');
  options.push({
    label: '--:--',
    value: '23:59',
  });
  for (var current = moment('1970-01-01 00:00:00'); current.isBefore(end); current.add(step, 'minutes')) {
    var time = current;
    options.push({
      label: time.format('HH:mm'),
      value: time.format('HH:mm:ss'),
    });
  }
  return options;
};

module.exports = {
  get: get,
  eachDay: eachDay,
  getTimeOptions: getTimeOptions,
  findDay: findDay,
};
